import { css } from 'styled-components';

// Breakpointy
export const breakpoints = {
    sm: '768px',   // Small devices (tablets, landscape phones)
    md: '1024px',  // Medium devices (laptops, small desktops)
    lg: '1280px',  // Large devices (desktops)
    xl: '1920px',  // Extra-large devices (4K monitors)
    xxl: '2560px', // Ultra-wide screens
};

// Media queries dla zakresów
export const media = {
    sm: `(max-width: ${parseInt(breakpoints.sm) - 1}px)`, // 0px - 767px
    md: `(min-width: ${breakpoints.sm}) and (max-width: ${parseInt(breakpoints.md) - 1}px)`, // 768px - 1023px
    lg: `(min-width: ${breakpoints.md}) and (max-width: ${parseInt(breakpoints.lg) - 1}px)`, // 1024px - 1279px
    xl: `(min-width: ${breakpoints.lg}) and (max-width: ${parseInt(breakpoints.xl) - 1}px)`, // 1280px - 1919px
    xxl: `(min-width: ${breakpoints.xl})`, // 1920px i wyżej (bez maksymalnej wartości)
};

// Utwórz funkcje dla stylów na różnych breakpointach
export const responsive = {
    sm: (styles) => css`
      @media ${media.sm} {
        ${styles}
      }
    `,
    md: (styles) => css`
      @media ${media.md} {
        ${styles}
      }
    `,
    lg: (styles) => css`
      @media ${media.lg} {
        ${styles}
      }
    `,
    xl: (styles) => css`
      @media ${media.xl} {
        ${styles}
      }
    `,
    xxl: (styles) => css`
      @media ${media.xxl} {
        ${styles}
      }
    `,
};
